import React from 'react';
import PropTypes from 'prop-types';
import AppUserGenericDTO from '../../DTOs/User/AppUserGenericDTO';
import MobileCard from './MobileCard';
import { formatPhoneNumber } from '../../utilities/PhoneFormat';
import { getSmsConsentLabel } from '../../utilities/SmsConsent';

export default function UserCardMobile(props) {
    const { user } = props;

    const address = [user.address1, user.address2, user.city, user.state, user.zip]
        .filter(Boolean)
        .join(', ');

    return (
        <MobileCard
            title={`${user.firstName} ${user.lastName}`}
            subtitle={user.username}
            fields={[
                { label: 'Phone', value: formatPhoneNumber(user.phone) },
                { label: 'Door code', value: user.doorCode ?? null },
                { label: 'Licence', value: `${user.driversLicenseNumber} (${user.licenseState})` },
                { label: 'Address', value: address || null },
                { label: 'Texts', value: getSmsConsentLabel(user.smsConsentStatus) },
            ]}
        />
    );
}

UserCardMobile.propTypes = {
    user: PropTypes.objectOf(AppUserGenericDTO),
};
